export default __webpack_public_path__ + "static/media/snam-logo.83634ede.png";